import React from 'react';
import { WebsiteDesignProps } from './types';
import { Sparkles, MousePointer2 } from 'lucide-react';
import { Button } from "@/components/ui/button";

const DigitalAgency: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Pixel & Code";

    return (
        <div className="bg-black text-white min-h-screen font-sans selection:bg-purple-500 selection:text-white">
            <nav className="p-8 flex justify-between items-center mix-blend-difference relative z-50">
                <div className="text-xl font-bold tracking-tight">{schoolName}</div>
                <Button className="rounded-full bg-white text-black hover:bg-gray-200 font-bold px-6">
                    Enroll
                </Button>
            </nav>

            <main className="relative overflow-hidden">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-purple-500 to-pink-500 rounded-full blur-[120px] opacity-40 animate-pulse"></div>
                
                <section className="min-h-screen flex flex-col justify-center items-center text-center relative z-10 px-4">
                     <div className="inline-flex items-center gap-2 border border-white/20 rounded-full px-4 py-1 text-sm mb-8 bg-white/5 backdrop-blur-md">
                         <Sparkles size={14} className="text-purple-400" />
                         <span>Future Ready Skills</span>
                     </div>
                     <h1 className="text-6xl md:text-8xl font-black mb-8 tracking-tight bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-500">
                         Create <br/> Digital Magic.
                     </h1>
                     <p className="text-xl text-gray-400 max-w-xl mb-12">
                         Become a full-stack master. From UI design to backend logic, we teach the complete lifecycle of digital products.
                     </p>
                     
                     <div className="flex gap-6 items-center">
                         <div className="flex -space-x-4">
                             <div className="w-10 h-10 rounded-full bg-gray-800 border-2 border-black"></div>
                             <div className="w-10 h-10 rounded-full bg-gray-700 border-2 border-black"></div>
                             <div className="w-10 h-10 rounded-full bg-gray-600 border-2 border-black"></div>
                         </div>
                         <span className="text-sm font-medium">Join 2,000+ creators</span>
                     </div>
                </section>

                <div className="absolute bottom-10 left-10 animate-bounce">
                    <MousePointer2 className="text-white" />
                </div>
            </main>
        </div>
    );
};

export default DigitalAgency;
